/**
 * PostsTemplate.tsx — "Posts observer results". Covers: type `post`.
 *
 * Every row across every entity is tagged `type: "PostItem"` directly (no
 * separate profile row to join against — unlike combined_id/insta_story,
 * this workflow's whole payload IS the post list), confirmed against
 * store/searcher/service.ts's `type === 'post'` handling and the old UI's
 * `PostItem.tsx`. Rendering is shared with SocialProfileTemplate's Posts
 * panel via ui/postCard.tsx, since both are "a list of PostItem rows",
 * just sourced differently.
 */
import * as React from 'react'
import { NoData, RawCard, ResCard } from '../ui/primitives'
import { extractPostItems, PostList } from '../ui/postCard'
import type { TemplateProps } from '../registry'

function extractAllPosts(apiData: any) {
  const entities: any[] = Array.isArray(apiData?.apiDataEntities) ? apiData.apiDataEntities : []
  return entities.flatMap((e) => extractPostItems(Array.isArray(e?.data) ? e.data : [], e?.from))
}

export function PostsTemplate({ apiData }: TemplateProps) {
  const posts = React.useMemo(() => extractAllPosts(apiData), [apiData])

  if (posts.length === 0) {
    return <NoData title="No posts returned" hint="No public posts matched this search." />
  }

  return (
    <>
      <ResCard title="Posts" count={posts.length}>
        <PostList posts={posts} />
      </ResCard>
      <RawCard data={apiData} />
    </>
  )
}
